$(document).on('click', '.submitForm', function (e) {
    e.preventDefault();
    var lang = $('html').attr('lang');
	if (lang == 'cs') {
		url = '/ajax/reservation-table/';
	} else {		
		url = '/'+lang+'/ajax/reservation-table/';
	}
    $.ajax({
        type: 'POST',
        url: url,
        data: $('#f-form').serialize(),
        dataType: 'json'
    }).done(function (data){
        // contactPerson
        if(data.error.contactPerson) {
            $('#contactPerson').css('border', '1px solid red');
        } else {
            $('#contactPerson').css('border', '0');
        }
        // email
        if(data.error.email) {
            $('#email').css('border', '1px solid red');
        } else {
            $('#email').css('border', '0');
        }

        // phone
        if(data.error.phone) {
            $('#phone').css('border', '1px solid red');
        } else {
            $('#phone').css('border', '0');
        }

        // time
        if(data.error.time) {
            $('#reserveTime').css('border', '1px solid red');
        } else {
            $('#reserveTime').css('border', '0');
        }
        
        // date
        if(data.error.date) {
            $('#reserveDate').css('border', '1px solid red');
        } else {
            $('#reserveDate').css('border', '0');
        }
                
        // numberOfPeople
        if(data.error.numberOfPeople) {
            $('#numberOfPeople').css('border', '1px solid red');
        } else {
            $('#numberOfPeople').css('border', '0');
        }        
        
        // celkova chyba
        if(data.error.contactPerson || data.error.email || data.error.phone || data.error.time || data.error.date || data.error.numberOfPeople) {
            $('.tableFormError').show();
            $('.tableFormSend').hide();
        } else {
            $('.tableFormError').hide();
            $('.tableFormSend').show();
            
            // zavreme form a smayeme polozky
            setTimeout(closedForn, 1500);            
        }
    });
    return false;
});

function closedForn(){
    $('#f-form')[0].reset();
    $('.restaurant-reserve-popup').removeClass('is-visible');
}